import styled from "styled-components";

export const $UninstalledInner = styled.div`
    border-radius: 12px;
    background-color: white;
    padding: 0 128px 64px 128px;
`;